import React, { useCallback, useContext, useMemo } from "react";
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from "../../../general-components/icon";
import { AnimationsContext } from "./animations-context";
import * as T from './types'

interface Props {
	isOut: boolean;
}

export default function DirectionalSelection(props: Props) {
	const {isOut} = props;
	const {
		selectedOutDirection,
		setSelectedOutDirection,
		selectedOutAnimation,
		selectedInDirection,
		setSelectedInDirection,
		selectedInAnimation
	} = useContext(AnimationsContext)

	const selectedDirection = useMemo(() => {
		return isOut ? selectedOutDirection : selectedInDirection;
	}, [isOut, selectedOutDirection, selectedInDirection]);

	const selectedAnimation = useMemo(() => {
		return isOut ? selectedOutAnimation : selectedInAnimation
	}, [isOut, selectedInAnimation, selectedOutAnimation]);

	const hidden = useMemo(() => {
		return !T.directionals.includes(selectedAnimation?.value)
	}, [selectedAnimation?.value])

	const onClick = (selected: number) => {
		if (isOut) {
			setSelectedOutDirection(selected);
		} else {
			setSelectedInDirection(selected);
		}
	}

	if (hidden) return <></>

	return (<div className="animation-row flex-center margin-top-medium">
		<div className='bl-font-p2'>Direction</div>
		<div className="directional-selection">
			<div
				className={classNames('first', 'number', selectedDirection === 0 ? 'active' : 'deactive',)}
				onClick={() => onClick(0)}
			>
				<Icon name={ICONS.ARROW_LEFT} size={16} color={selectedDirection === 0 ? COLORS.TEXT_GRAY_900 : COLORS.TEXT_GRAY_400} />
			</div>
			<div
				className={classNames('number', selectedDirection === 1 ? 'active' : 'deactive')}
				onClick={() => onClick(1)}
			>
				<Icon name={ICONS.ARROW_RIGHT} size={16} color={selectedDirection === 1 ? COLORS.TEXT_GRAY_900 : COLORS.TEXT_GRAY_400} />
			</div>
			<div
				className={classNames('number',selectedDirection === 2 ? 'active' : 'deactive')}
				onClick={() => onClick(2)}
			>
				<Icon name={ICONS.ARROW_UP} size={16} color={selectedDirection === 2 ? COLORS.TEXT_GRAY_900 : COLORS.TEXT_GRAY_400} />
			</div>
			<div
				className={
				classNames('last','number',selectedDirection === 3 ? 'active' : 'deactive')}
				onClick={() => onClick(3)}
			>
				<Icon name={ICONS.ARROW_DOWN} size={16} color={selectedDirection === 3 ? COLORS.TEXT_GRAY_900 : COLORS.TEXT_GRAY_400} />
			</div>
		</div>
	</div>)
}
